export default {
  minPrice: {
    id: 'finder_budget_min_price',
    defaultMessage: 'Min ({currency})',
  },
  maxPrice: {
    id: 'finder_budget_max_price',
    defaultMessage: 'Max ({currency})',
  },
} as const
